// HorizontalListing.js
import React from "react";
import { useNavigate } from "react-router-dom";
import ListItem from "./ListItem";
import ShopButton from "./ShopButton";
import HorizontalScroll from "./HorizontalScroll";

import "../styles/global.css";
import isProductAvailable from "../functions/isProductAvailable";


const breakpoints = [390, 755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)


const HorizontalListing = ({
  title,
  products,
  categoryLink,
  limit = 10,
  displayShowAllButton = true,
  priceTheme,
  buttonText,
  ribbonSettings,
}) => {
  const navigate = useNavigate();

  const filteredAndSortedProducts = products.sort((a, b) => {
    const aUnavailable = !isProductAvailable(a);
    const bUnavailable = !isProductAvailable(b);

    // Unavailable products should go to the end.
    if (aUnavailable && !bUnavailable) return 1;
    if (!aUnavailable && bUnavailable) return -1;

    // If both are either available or unavailable, sort by order_category_row
    const aRow = a.order_category_row || 0;
    const bRow = b.order_category_row || 0;

    if (aRow > 0 && bRow > 0) {
      return aRow - bRow;
    } else if (aRow > 0) {
      return -1;
    } else if (bRow > 0) {
      return 1;
    }
    return 0;
  });

  return (
    <div css={styles.container}>
      <div css={styles.title}>{title}</div>
      <HorizontalScroll>
        <div css={{ ...styles.grid }}>
          {filteredAndSortedProducts && filteredAndSortedProducts.length > 0 ? (
            <>
              {filteredAndSortedProducts.slice(0, limit).map((product, index) => (
                <div key={product.id || index} css={{ ...styles.item }}>
                  <ListItem product={product} priceTheme={priceTheme} ribbonSettings={ribbonSettings} />
                </div>
              ))}
            </>
          ) : (
            <p css={styles.empty}>No products found.</p>
          )}
        </div>
      </HorizontalScroll>

      {displayShowAllButton && (
        <div css={{ padding: "0 10px" }}>
          <ShopButton containerStyles={styles.shop.button}
            buttonStyle={styles.shop.text} text={`${buttonText}`} theme="dark" onClick={() => navigate(`${categoryLink}`)} arrow />
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    padding: "0 10px",
    gap: "10px",
    [mq[1]]: {
      gap: "15px",
    },
  },
  title: {
    fontSize: "1.4rem",
    fontWeight: 700,
    display: "flex",
    color: "black",
    padding: "0 10px",
    [mq[1]]: {
      fontSize: "1.75rem",
    },
  },
  item: {
    flex: "0 0 auto",
    maxWidth: "120px",
    [mq[0]]: {
      maxWidth: "158px",
    },
    [mq[1]]: {
      maxWidth: "208px",
    },
  },
  empty: {
    fontSize: "1rem",
    color: "gray",
    marginLeft: "10px",
  },
  shop: {
    button: {
      maxWidth: "380px",
      margin: "0px auto",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[1]]: {
        fontSize: "1.25rem",
        lineHeight: "1.25rem",
      },
    }
  }
};

export default HorizontalListing;
